import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { useDirection } from '../../context/DirectionContext';
import { translate as tr } from '../../i18n/translations';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { lang } = useDirection();
  const { state } = useAuth();

  if (state.isLoading) {
    return <LoadingSpinner message={tr('auth.authenticating', lang)} />;
  }

  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
